export const SET_NOTIFS_COUNT = 'notifs/set'

export const setNotifsCount = (notifsCount) => ({
  type: SET_NOTIFS_COUNT,
  notifsCount,
})
